module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHhJREFUKM+VkDEOAjEMBP1WPsADKHbfSUVPje4KYK6IQXaUAjJdNJrYCYIQRp2LQkEQMQQwW7IP5dwEY64JCNBLp6lwS/g8s30FY8w9ARg3U6EDYprhUTDuApi9sCw8C8tCPVPBrPm9oFysCv/NIIR5F8ZnN2EFQRzuz4DHtCLOagAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/video-x-generic.png
// module id = r2AX
// module chunks = 1